// Module
var code = "<a data-bind=\"click: $data.ShowQueryBuilder.bind($data)\" href=\"#\"> <img src=\"img/Custom/sql-256.png\" class=\"query-icon\"> </a>";
// Exports
export default code;